import { css as _css } from "@emotion/core";
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React, { useState } from 'react';
import { Collapse } from 'react-collapse';
import { ReactHeight } from 'react-height';
import { withMedia } from 'react-media-query-hoc';
import { ChevronUpIcon, ChevronDownIcon } from '@domain-group/fe-co-icon';
import { useAllhomesApi } from '@domain-group/fe-co-allhomes-api-client';
import { ToggledFeatureKey } from '@domain-group/fe-allhomes-library';
import { Button } from '@domain-group/fe-co-allhomes-design-system';
import * as styles from './allhomes-collapsible-description.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
const DEFAULT_HEIGHT = 220;
const AllhomesCollapsibleDescription = _ref => {
  let description = _ref.description,
    _ref$maxPreviewHeight = _ref.maxPreviewHeight,
    maxPreviewHeight = _ref$maxPreviewHeight === void 0 ? DEFAULT_HEIGHT : _ref$maxPreviewHeight,
    _ref$showLabel = _ref.showLabel,
    showLabel = _ref$showLabel === void 0 ? 'Show more' : _ref$showLabel,
    _ref$hideLabel = _ref.hideLabel,
    hideLabel = _ref$hideLabel === void 0 ? 'Show less' : _ref$hideLabel,
    _ref$showLabelMobile = _ref.showLabelMobile,
    showLabelMobile = _ref$showLabelMobile === void 0 ? 'About' : _ref$showLabelMobile,
    _ref$hideLabelMobile = _ref.hideLabelMobile,
    hideLabelMobile = _ref$hideLabelMobile === void 0 ? 'About' : _ref$hideLabelMobile,
    _ref$onClick = _ref.onClick,
    _onClick = _ref$onClick === void 0 ? () => {} : _ref$onClick,
    _ref$media = _ref.media,
    media = _ref$media === void 0 ? {
      mobile: false
    } : _ref$media;
  const _useAllhomesApi = useAllhomesApi(),
    toggledFeatures = _useAllhomesApi.toggledFeatures;
  const allowDarkMode = toggledFeatures[ToggledFeatureKey.DARK_MODE] || toggledFeatures[ToggledFeatureKey.AUTO_DARK_MODE];
  const _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isOpen = _useState2[0],
    setIsOpen = _useState2[1];
  const _useState3 = useState(-1),
    _useState4 = _slicedToArray(_useState3, 2),
    contentHeight = _useState4[0],
    setContentHeight = _useState4[1];
  const updateContentHeight = newHeight => {
    if (contentHeight === -1) {
      setContentHeight(newHeight);
    }
  };
  const isContentLong = () => contentHeight > (maxPreviewHeight !== null && maxPreviewHeight !== void 0 ? maxPreviewHeight : DEFAULT_HEIGHT);
  const calculateCollapseHeight = () => {
    if (isContentLong() && !isOpen) {
      return maxPreviewHeight !== null && maxPreviewHeight !== void 0 ? maxPreviewHeight : DEFAULT_HEIGHT;
    }
    return -1;
  };
  const renderButton = (show, hide) => {
    const Icon = isOpen ? ChevronUpIcon : ChevronDownIcon;
    return ___EmotionJSX("button", {
      type: "button",
      css: /*#__PURE__*/_css([styles.toggleButton, !isOpen && styles.toggleButtonClosed]),
      onClick: () => {
        if (_onClick) {
          _onClick(isOpen ? 'hide' : 'show');
          setIsOpen(curr => !curr);
        }
      }
    }, ___EmotionJSX(Icon, {
      css: styles.toggleButtonIcon
    }), ___EmotionJSX("span", {
      css: /*#__PURE__*/_css([styles.toggleButtonLabel, !isOpen && styles.toggleButtonClosedLabel])
    }, isOpen ? hide : show));
  };
  const contentBlock = ___EmotionJSX(ReactHeight, {
    onHeightReady: updateContentHeight
  }, ___EmotionJSX("div", {
    css: styles.contentBlock,
    dangerouslySetInnerHTML: {
      __html: description
    }
  }));
  const isMobile = Boolean(media === null || media === void 0 ? void 0 : media.mobile);
  return ___EmotionJSX("div", {
    className: "allhomes-collapsible-description"
  }, isMobile && ___EmotionJSX(Collapse, {
    isOpened: isOpen
  }, contentBlock), isMobile && renderButton(showLabelMobile, hideLabelMobile), !isMobile && (isContentLong() ? ___EmotionJSX("div", null, ___EmotionJSX(Collapse, {
    css: styles.collapse,
    isOpened: true,
    fixedHeight: calculateCollapseHeight()
  }, contentBlock, !isOpen && ___EmotionJSX("div", {
    css: /*#__PURE__*/_css([styles.fade, allowDarkMode && styles.darkFade])
  })), ___EmotionJSX(Button, {
    appearance: "outline",
    size: "small",
    icon: isOpen ? ___EmotionJSX(ChevronUpIcon, {
      size: "small"
    }) : ___EmotionJSX(ChevronDownIcon, {
      size: "small"
    }),
    iconPosition: "right",
    onClick: () => {
      if (_onClick) {
        _onClick(isOpen ? 'hide' : 'show');
        setIsOpen(curr => !curr);
      }
    }
  }, isOpen ? hideLabel : showLabel)) : contentBlock));
};
export { AllhomesCollapsibleDescription as BaseAllhomesCollapsibleDescription };
export default withMedia(AllhomesCollapsibleDescription);